<div class="row">
  <div class="col-12">
    <div class="card">
      <div class="card-body">
        <form #f="ngForm" (ngSubmit)="onSubmit(f)" novalidate *ngIf="loaded && !isCaseClosed()">
          <div class="row align-items-end">
            <div class="col-md-6 mb-4">
              <label for="inputDescripcionDia" class="form-label" i18n>Descripción de día inhábil (*)</label>
              <input type="text" class="form-control" id="inputDescripcionDia" name="descripcion"
                #descripcion="ngModel" [(ngModel)]="nuevoDiaInhabil.descripcion" required
                [ngClass]="{ 'is-invalid': (f.submitted && descripcion.invalid) || (descripcion.invalid && (descripcion.dirty || descripcion.touched))}">
            </div>

            <div class="col-md-4 mb-4">
              <div class="btn-group mt-2 date-toggle" role="group" aria-label="Tipo de fecha">
                <button type="button" class="btn btn-outline-secondary"
                  [class.active]="!useDateRange" (click)="setDateRange(false)">
                  <span i18n>Día único</span>
                </button>
                <button type="button" class="btn btn-outline-secondary"
                  [class.active]="useDateRange" (click)="setDateRange(true)">
                  <span i18n>Rango de fechas</span>
                </button>
              </div>
            </div>

            <div class="col-md-2 text-end mb-4"></div>
          </div>

          <div class="row align-items-end">
            <div class="col-md-3 mb-4" *ngIf="!useDateRange">
              <label for="inputFechaUnica" class="form-label" i18n>Fecha (*)</label>
              <input type="date" class="form-control" id="inputFechaUnica" name="fecha_fin"
                #fechaFinUnica="ngModel" [(ngModel)]="nuevoDiaInhabil.fecha_fin" required
                [ngClass]="{ 'is-invalid': (fechaFinUnica.invalid && f.submitted) || (fechaFinUnica.invalid && (fechaFinUnica.dirty || fechaFinUnica.touched)) }">
            </div>
            <div class="col-md-2 text-end mb-4" *ngIf="!useDateRange">
              <button type="submit" class="btn btn-primary waves-effect waves-light"
                [disabled]="f.invalid || disableOptions || disableAnadirDiaInhabil">
                <span i18n>Añadir día inhábil</span>
              </button>
            </div>

            <div class="col-md-3 mb-4" *ngIf="useDateRange">
              <label for="inputFechaInicio" class="form-label" i18n>Fecha inicio (*)</label>
              <input type="date" class="form-control" id="inputFechaInicio" name="fecha_inicio"
                #fechaInicio="ngModel" [(ngModel)]="nuevoDiaInhabil.fecha_inicio" required
                [ngClass]="{ 'is-invalid': (fechaInicio.invalid && f.submitted) || (fechaInicio.invalid && (fechaInicio.dirty || fechaInicio.touched)) }">
            </div>

            <div class="col-md-3 mb-4" *ngIf="useDateRange">
              <label for="inputFechaFin" class="form-label" i18n>Fecha fin (*)</label>
              <input type="date" class="form-control" id="inputFechaFin" name="fecha_fin"
                #fechaFin="ngModel" [(ngModel)]="nuevoDiaInhabil.fecha_fin" required
                [ngClass]="{ 'is-invalid': (fechaFin.invalid && f.submitted) || (fechaFin.invalid && (fechaFin.dirty || fechaFin.touched)) }">
            </div>
            <div class="col-md-2 text-end mb-4" *ngIf="useDateRange">
              <button type="submit" class="btn btn-primary waves-effect waves-light"
                [disabled]="f.invalid || disableOptions || disableAnadirDiaInhabil">
                <span i18n>Añadir día inhábil</span>
              </button>
            </div>
          </div>

          <input type="hidden" name="tipo" [(ngModel)]="nuevoDiaInhabil.tipo">
        </form>

        <h5 class="section-title" i18n>Días inhábiles</h5>
        <app-advanced-table *ngIf="loaded" [tableData]="records" [columns]="columns" [pagination]="true"
          [pageSizeOptions]="pageSizeOptions" [hasRowSelection]="true" [isSearchable]="true"
          (search)="searchData($event)" [isSortable]="true" (sort)="onSort($event)" [buttonLink]="buttonLink"
          [disableOptions]="disableOptions || disableAnadirDiaInhabil" [buttonTitle]="buttonTitle"
          (deleteClick)="openDeleteModal($event)">
        </app-advanced-table>

        <div id="status" *ngIf="!loaded && !error">
          <div class="spinner">
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>

        <ngb-alert [dismissible]="false" type="danger" *ngIf="error">
          {{ error }}
        </ngb-alert>
      </div>
    </div>
  </div>
</div>

<div class="confirm-delete-modal" *ngIf="showConfirmDeleteModal">
  <div class="confirm-delete-modal-content">
    <div class="confirm-delete-modal-header">
      <h5 class="confirm-delete-modal-title" i18n>Confirmar Borrado</h5>
    </div>
    <div class="confirm-delete-modal-body">
      <p><span i18n>¿Estás seguro de que deseas borrar el día inhábil de</span> {{ diaInhabilToDelete?.descripcion }}?</p>
    </div>
    <div class="confirm-delete-modal-footer">
      <button type="button" class="btn btn-danger waves-effect waves-light" style="margin-right: 20px;"
        (click)="confirmDelete()">
        <span class="btn-label"><i class="fe-trash"></i></span><span i18n>Borrar</span>
      </button>
      <button type="button" class="btn btn-secondary waves-effect waves-light" (click)="closeDeleteModal()">
        <span class="btn-label"><i class="fe-x"></i></span><span i18n>Cancelar</span>
      </button>
    </div>
  </div>
</div>
